<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Pessoa Interface</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                            <div class="heading-elements">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar" v-if="getPermissionFw('pessoainterface.store')"><i class="fa fa-plus"></i></a></li>
                                    <li><a @click="onCreateConexao()" v-b-tooltip title="Cadastrar Conexão" v-if="getPermissionFw('pessoaconexao.store')"><i class="fa fa-plus"></i></a></li>
                                    <li><a @click="onFilterReset()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a></li>
                                    <li><a @click="expandFullscreenFw()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreenFw()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHideFw()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros"  v-if="getPermissionFw('pessoainterface.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inutilizar Registros"  v-if="getPermissionFw('pessoainterface.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar :tabela="'pessoa_interface'">
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData"><div class="loadingDataSpinner"><spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                                    <vuetable ref="vuetable"
                                            api-url="/api/pessoainterface"
                                            :fields="fields"
                                            :css="css"
                                            :append-params="moreParams"
                                            track-by="pesint_id"
                                            pagination-path=""
                                            @vuetable:load-error="onError"
                                            @vuetable:pagination-data="onPaginationData"
                                            @vuetable:cell-clicked="onDetail"
                                            detail-row-component="pessoainterface-detalhes"
                                            @vuetable:loaded="onLoaded"
                                          >
                                          <template slot="status" slot-scope="props">
                                              <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                          </template>
                                          <template slot="identificacao" slot-scope="props">
                                              <span v-if="props.rowData.pessoa.pessoa_juridica!==null" v-b-tooltip :title="'CNPJ: '+onFormataCnpj(props.rowData.pessoa.pessoa_juridica.cnpj_base,props.rowData.pessoa.pessoa_juridica.cnpj_filial,props.rowData.pessoa.pessoa_juridica.cnpj_digito)">{{props.rowData.pessoa.pessoa_juridica.razao_social}}</span>
                                              <span v-if="props.rowData.pessoa.pessoa_exterior!==null" v-b-tooltip :title="'CUIT: '+props.rowData.pessoa.pessoa_exterior.cuit">{{ props.rowData.pessoa.pessoa_exterior.nome }}</span>
                                              <span v-if="props.rowData.pessoa.pessoa_fisica!==null"   v-b-tooltip :title="'CPF: '+props.rowData.pessoa.pessoa_fisica.cpf">{{ props.rowData.pessoa.pessoa_fisica.nome }}</span>
                                          </template>
                                          <template slot="actions" slot-scope="props">
                                            <div class="custom-actions">
                                                <a @click="onEdit(props.rowData, props.rowIndex)" v-b-tooltip title="Editar"  v-if="getPermissionFw('pessoainterface.update')"><i class="fa fa-edit"></i></a>
                                                <a @click="onCreateInterfaceFtp(props.rowData)" v-b-tooltip title="Criar interface FTP"  v-if="getPermissionFw('pessoainterfaceftp.store') && props.rowData.pessoa.pessoa_conexao_ftp.length>0"><i class="fa fa-upload"></i></a>
                                                <span style="cursor: not-allowed" v-b-tooltip title="Favor vincular uma conexão FTP para essa pessoa."  v-if="getPermissionFw('pessoainterfaceftp.store') && props.rowData.pessoa.pessoa_conexao_ftp.length==0" class="fa-stack">
                                                  <i class="fa fa-upload fa-stack-1x"></i>
                                                  <i class="fa fa-ban fa-stack-2x text-danger"></i>
                                                </span>
                                                <a @click="onCreateInterfaceEmail(props.rowData)" v-b-tooltip title="Criar interface Email"  v-if="getPermissionFw('pessoainterfaceemail.store') && props.rowData.pessoa.pessoa_conexao_email.length>0"><i class="fa fa-envelope"></i></a>
                                                <span style="cursor: not-allowed" v-b-tooltip title="Favor vincular uma conexão Email para essa pessoa."  v-if="getPermissionFw('pessoainterfaceemail.store') && props.rowData.pessoa.pessoa_conexao_email.length==0" class="fa-stack">
                                                  <i class="fa fa-envelope fa-stack-1x"></i>
                                                  <i class="fa fa-ban fa-stack-2x text-danger"></i>
                                                </span>
                                                <a @click="onCreateInterfaceApi(props.rowData)" v-b-tooltip title="Criar interface API"  v-if="getPermissionFw('pessoainterfaceapi.store') && props.rowData.pessoa.pessoa_conexao_api.length>0"><i class="fa fa-code-fork"></i></a>
                                                <span style="cursor: not-allowed" v-b-tooltip title="Favor vincular uma conexão API para essa pessoa."  v-if="getPermissionFw('pessoainterfaceapi.store') && props.rowData.pessoa.pessoa_conexao_api.length==0" class="fa-stack">
                                                  <i class="fa fa-code-fork fa-stack-1x"></i>
                                                  <i class="fa fa-ban fa-stack-2x text-danger"></i>
                                                </span>
                                                <span v-if="getPermissionFw('pessoainterface.status')">
                                                    <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                                    <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                                </span>
                                                <a v-if="props.rowData.pessoa_interface_api.length>0 || props.rowData.pessoa_interface_email.length>0 || props.rowData.pessoa_interface_ftp.length>0" @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                              </button>
                                            </div>
                                          </template>
                                    </vuetable>
                                </div>
                            <div>
                                <div class='col-md-12'>
                                    <div class="pull-left pagination-detail">
                                        <vuetable-pagination-info ref="paginationInfo"
                                                                  :css="css.pagination"
                                                                  info-class="pull-left"
                                        ></vuetable-pagination-info>
                                    </div>
                                    <div class="pull-right m-a-0">
                                        <vuetable-pagination ref="pagination"
                                                             :css="css.pagination"
                                                             @vuetable-pagination:change-page="onChangePage"
                                        ></vuetable-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PessoaInterfaceForm ref="pessoainterfaceform" :metodo="onFilterReset" :tabela="'pessoa_interface'" :rota="'pessoainterface'"></PessoaInterfaceForm>
        <PessoaConexaoSelectForm ref="pessoaconexaoselectform" :metodo="onFilterReset"></PessoaConexaoSelectForm>
        <PessoaInterfaceFtpForm ref="pessoainterfaceftpform" :metodo="onFilterReset"></PessoaInterfaceFtpForm>
        <PessoaInterfaceApiForm ref="pessoainterfaceapiform" :metodo="onFilterReset"></PessoaInterfaceApiForm>
        <PessoaInterfaceEmailForm ref="pessoainterfaceemailform" :metodo="onFilterReset"></PessoaInterfaceEmailForm>

    </div>
</div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import PessoaInterfaceFilterBar from './PessoaInterfaceFilterBar'
import PessoaInterfaceForm from './PessoaInterfaceForm'
import PessoaInterfaceFtpForm from './PessoaInterfaceFtpForm'
import PessoaInterfaceApiForm from './PessoaInterfaceApiForm'
import PessoaInterfaceEmailForm from './PessoaInterfaceEmailForm'
import PessoaConexaoSelectForm from './PessoaConexaoSelectForm'
import PessoaInterfaceDetalhes from './PessoaInterfaceDetalhes'

Vue.component('pessoainterface-detalhes', PessoaInterfaceDetalhes);

export default {
components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    PessoaInterfaceForm,
    PessoaInterfaceFtpForm,
    PessoaInterfaceApiForm,
    PessoaInterfaceEmailForm,
    PessoaConexaoSelectForm,
    'vuetable-filterbar': PessoaInterfaceFilterBar
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      form: new Form({ cd: '',
                       descr: '',
                       pesint_id: '',
                       status: []
                   }),
     helpForm: new Form({recordCollection: [], status: ''}),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: 'interface_gateway.descr',
        title: 'Gateway'
      },
      {
        name: '__slot:identificacao',
        title: 'Pessoa'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
mounted() {
    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
    this.$events.$on('filter-reset', e => this.onFilterReset());
  },
methods: {
    onDetail(data, field, event) {
        this.$refs.vuetable.toggleDetailRow(data.pesint_id);
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onFilterSet (data_filter) {
        this.loadingData = true;
        this.moreParams = {
            'cd': data_filter.cd,
            'descr': data_filter.descr,
            'status': data_filter.status.value
        }
        Vue.nextTick( () => {this.$refs.vuetable.reload(); })
    },
    onFilterReset () {
        this.loadingData = true;
        this.moreParams = {}
        Vue.nextTick( () => this.$refs.vuetable.refresh())
    },
    onLoaded: function () {
        this.dataExport = this.$refs.vuetable.tableData;
        this.loadingData = false;
        this.$store.commit('setVuetableFilterButton', false);
    },
    onCreateConexao ()
    {
      this.$refs.pessoaconexaoselectform.onCreate();
    },
    onCreateInterfaceFtp (data)
    {
      this.$refs.pessoainterfaceftpform.onCreate(data);
    },
    onCreateInterfaceEmail (data)
    {
      this.$refs.pessoainterfaceemailform.onCreate(data);
    },
    onCreateInterfaceApi (data)
    {
      this.$refs.pessoainterfaceapiform.onCreate(data);
    },
    onCreate ()
    {
      this.$refs.pessoainterfaceform.onCreate();
    },
    onEdit (data, index)
    {
      this.id = data.pesint_id;
      this.$refs.pessoainterfaceform.onEdit(data, index, this.id);
    },
    onActivateDesactivate(action, data, tipo)
    {
        // Tipo = true = Checkbox
        this.helpForm.status = action;
        if(tipo)
        {

            this.helpForm.recordCollection = [];
            this.helpForm.recordCollection.push(data.pesint_id );
        }
        else
        {
            this.helpForm.recordCollection = [];
            this.$refs.vuetable.selectedTo.forEach((obj)=>{
                this.helpForm.recordCollection.push(obj)
            });
        }
        this.$refs.pessoainterfaceform.onActivateDesactivate(this.helpForm);
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
        var cnpj_formatado
        var pad = "00000000"
        var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
        var pad = "0000"
        var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
        var pad = "00"
        var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;

        return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    },
    isFullscreen: {
        get() {
            return this.$store.getters.is_full_screen;
        }
    }
}
}
</script>
